import { render, staticRenderFns } from "./Manifestacao.vue?vue&type=template&id=14864702&"
import script from "./Manifestacao.vue?vue&type=script&lang=js&"
export * from "./Manifestacao.vue?vue&type=script&lang=js&"
import style0 from "./Manifestacao.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Manifestacao.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports